<template>
  <div class="pageChangeResultBox">
    <el-result :icon="iconTpye_data ? iconTpye_data : iconTpye"
               :title="title_data ? $t(title_data) : title"
               :subTitle="subTitle_data ? $t(subTitle_data) : subTitle">
      <template slot="extra">
        <el-button type="primary" size="medium" @click="redirectUrl">{{ $t('h.common.back') }}</el-button>
      </template>
    </el-result>
  </div>
</template>

<script>
export default {
  mounted() {
    console.log(this.$route.query);
    this.iconTpye_data = this.$route.query.iconTpye;
    this.title_data = this.$route.query.title;
    this.subTitle_data = this.$route.query.subTitle;

    this.redirect_data = this.$route.query.redirect;
  },
  data() {
    return {
      iconTpye_data: '',
      title_data: '',
      subTitle_data: '',

      redirect_data: '',//最终要跳转的网页
    }
  },
  props: {
    //标题
    title: {
      type: String,
      default: 'tip'
    },
    //跳转类型
    iconTpye: {
      type: String,
      default: 'success'
    },
    //提示
    subTitle: {
      type: String,
      default: 'Please follow the prompts to operate'
    },
    //要跳转的url
    redirect: {
      type: String,
      default: '/account/login'
    },
  },
  methods: {
    redirectUrl() {
      this.$router.push(this.redirect_data ? this.redirect_data : redirect);
    }
  }

}
</script>

<style scoped>
.pageChangeResultBox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/pageChangeResult/pageChangeResult.vue